import { render, staticRenderFns } from "./createFromCopy.vue?vue&type=template&id=72f49c5c"
import script from "./createFromCopy.vue?vue&type=script&lang=js"
export * from "./createFromCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72f49c5c')) {
      api.createRecord('72f49c5c', component.options)
    } else {
      api.reload('72f49c5c', component.options)
    }
    module.hot.accept("./createFromCopy.vue?vue&type=template&id=72f49c5c", function () {
      api.rerender('72f49c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lifehikes/hike/createFromCopy.vue"
export default component.exports